module.exports = __webpack_public_path__ + "static/media/red-bg-landscape.749144b4.webp";